'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by Administrator on 2016/7/24.
                                          */

// import { ExperienceShopRegisterForm } from 'components';

// import { push } from 'react-router-redux';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _experienceShop = require('redux/modules/experienceShop');

var experienceShopActions = _interopRequireWildcard(_experienceShop);

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExperienceShopProducts = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch(experienceShopActions.getProducts('')));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    productsData: state.experienceShop.productsData
  };
}, (0, _extends3.default)({}, experienceShopActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ExperienceShopProducts, _Component);

  function ExperienceShopProducts() {
    (0, _classCallCheck3.default)(this, ExperienceShopProducts);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ExperienceShopProducts).call(this));

    _this.state = {
      orderItem: '',
      direction: '',
      filter: '',
      currentPage: 0
    };
    return _this;
  }

  (0, _createClass3.default)(ExperienceShopProducts, [{
    key: 'onItemClick',
    value: function onItemClick(clickItem) {
      var getProducts = this.props.getProducts;
      var _state = this.state;
      var direction = _state.direction;
      var filter = _state.filter;

      var currentDirection = 'ASC';
      var currentFilter = filter;
      switch (clickItem) {
        case 'price':
        case 'owner':
          if (direction === 'ASC') {
            currentDirection = 'DESC';
          }
          this.setState({
            orderItem: clickItem,
            direction: currentDirection
          });
          break;
        default:
          this.setState({
            filter: '',
            orderItem: '',
            direction: ''
          });
          currentFilter = '';
          currentDirection = '';
          break;
      }
      /*
       if (clickItem === '') {
       this.setState({
       filter: '',
       orderItem: '',
       direction: ''
       });
       currentFilter = '';
       currentDirection = '';
       } else if (clickItem === 'buymoney') {
       if (direction === 'ASC') {
       currentDirection = 'DESC';
       }
       this.setState({
       orderItem: 'buymoney',
       direction: currentDirection
       });
       } */
      if (getProducts) {
        getProducts(currentFilter, 0, { orderItem: clickItem, direction: currentDirection });
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var getProducts = this.props.getProducts;
      var _state2 = this.state;
      var orderItem = _state2.orderItem;
      var direction = _state2.direction;
      var filter = _state2.filter;

      if (getProducts) {
        this.setState({
          currentPage: page
        });
        getProducts(filter, page, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch() {
      var getProducts = this.props.getProducts;
      var _state3 = this.state;
      var orderItem = _state3.orderItem;
      var direction = _state3.direction;
      var filter = _state3.filter;

      var value = this.refs.searchInput.value;
      if (getProducts) {
        var currentFilter = filter;
        if (value && value !== '') {
          currentFilter = (0, _extends3.default)({}, filter, { FindValue: value });
        } else {
          delete currentFilter.FindValue;
        }
        this.setState({
          filter: currentFilter
        });
        getProducts(currentFilter, 0, { orderItem: orderItem, direction: direction });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var productsData = this.props.productsData;
      var orderItem = this.state.orderItem;

      var styles = require('./ExperienceShopProducts.scss');
      var productsDataShow = '';
      var totalPageNumber = 1;
      var errorLabel = '';
      if (productsData) {
        var experienceShopProducts = productsData.experienceShopProducts;
        var experienceShopProductsError = productsData.experienceShopProductsError;
        var experienceShopProductsRecordCount = productsData.experienceShopProductsRecordCount;
        var experienceShopProductsPagesize = productsData.experienceShopProductsPagesize;

        if (experienceShopProductsError) {
          errorLabel = _react2.default.createElement(_components.ErrorLabel, { error: experienceShopProductsError });
        } else if (experienceShopProducts instanceof Array && experienceShopProducts.length > 0) {
          productsDataShow = experienceShopProducts.map(function (product, index) {
            return _react2.default.createElement(
              'li',
              { key: product.productId + index, className: styles.productli },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/personalcenter/experienceshop/experienceshopproductdetails/' + product.productId },
                _react2.default.createElement('img', { className: styles.imga, src: product.img, alt: '' }),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'dl',
                    null,
                    _react2.default.createElement(
                      'dd',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        product.productName
                      )
                    ),
                    _react2.default.createElement(
                      'dd',
                      null,
                      '所有人：',
                      product.owner
                    ),
                    _react2.default.createElement(
                      'dd',
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { letterSpacing: 14 } },
                        '价'
                      ),
                      '格：',
                      product.price
                    )
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    product.isSaleOut === '1' ? '已下架' : ''
                  )
                )
              )
            );
          });
          totalPageNumber = parseInt(experienceShopProductsRecordCount / experienceShopProductsPagesize, 10);
          if (experienceShopProductsRecordCount % experienceShopProductsPagesize > 0) {
            ++totalPageNumber;
          }
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'ul',
          { className: styles.jsdd },
          _react2.default.createElement(
            'li',
            { className: orderItem === '' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('');
              } },
            '全部'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'price' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('price');
              } },
            '价格'
          ),
          _react2.default.createElement(
            'li',
            { className: orderItem === 'owner' ? styles.border : '', onClick: function onClick() {
                return _this2.onItemClick('owner');
              } },
            '所有人'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.jsallshou },
          _react2.default.createElement('input', { ref: 'searchInput', type: 'text' }),
          _react2.default.createElement(
            'div',
            { onClick: this.onSearch.bind(this), className: styles.img },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/per_center/shc.png', alt: '' })
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('div', { className: styles.linka }),
        _react2.default.createElement(
          'ul',
          { className: styles.productlie },
          productsDataShow
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        errorLabel,
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return ExperienceShopProducts;
}(_react.Component), _class2.propTypes = {
  productsData: _react.PropTypes.object,
  getProducts: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = ExperienceShopProducts;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopProducts/ExperienceShopProducts.js
 ** module id = 1478
 ** module chunks = 0
 **/